// CSS Modules - component class name prefix: ShopLogin__

<template>
  <div :class="$style.container">
    <a
      :class="$style.loginPopper"
      v-tippy="{
        theme: 'wika light tooltip tooltip-bottom',
        interactive: true,
        reactive: true,
        placement: 'bottom',
        flip: false,
        animation: 'perspective',
        animateFill: false,
        arrow: true,
        distance: 11,
        zIndex: 10000,
        html: '#loginPopperContent',
        trigger: isMobile ? 'click' : 'mouseenter focus'
      }"
      ref="tippy"
      @init="initLoginTippy"
    >
      <i class="fas fa-user"></i>
      <span>{{ loggedIn ? config.loggedInText : config.loginText }}</span>
    </a>
    <div id="loginPopperContent" :class="$style.popperContent">
      <ul v-if="loggedIn">
        <li v-for="(link, index) in config.loginMenu" :key="index">
          <a
            v-if="link.url === 'logout'"
            v-html="link.title"
            @click.prevent="logout"
          ></a>
          <a v-else :href="link.url" v-html="link.title"></a>
        </li>
      </ul>
      <div v-else class="columns is-mobile is-multiline">
        <form :class="[$style.loginForm, 'column is-full']">
          <div class="columns is-mobile is-multiline">
            <div class="column is-full">
              <FormInput
                v-model="email"
                type="email"
                :placeholder="config.emailInput"
              />
              <FormInput
                v-model="password"
                type="password"
                :placeholder="config.passwordInput"
              />
              <Button
                colour="orange"
                :text="config.loginText"
                :isForm="true"
                @close="login"
              >
              </Button>
            </div>
            <div :class="[$style.passReset, 'column is-full']">
              <a :href="config.passwordUrl">
                {{ config.passwordText }}
              </a>
            </div>
          </div>
        </form>
        <div :class="[$style.registration, 'column is-full']">
          <Button
            isLink
            colour="blue"
            :href="config.registrationUrl"
            :text="config.registrationText"
          >
          </Button>
        </div>
      </div>
    </div>
    <Modal :isModalOpen="isModalOpen" @closeModal="closeModal">
      <div :class="$style.modal">
        <h4>{{ config.warningHeadline }}</h4>
        <p>{{ config.warningText }}</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import FormInput from "../FormInput/FormInput";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import ShopPostMessages from "../../globals/constants/shopPostMessages";
import LoginWithUrl from "../../xhr/login/loginWithUrl";
import logoutWithUrl from "../../xhr/login/logoutWithUrl";
import checkLoginWithUrl from "../../xhr/login/checkLoginWithUrl";
import "url-polyfill";

export default {
  name: "ShopLogin",
  components: {
    FormInput,
    Button,
    Modal
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loggedIn: false,
      interval: null,
      isMobile: isMobile,
      isModalOpen: false,
      email: null,
      password: null
    };
  },
  methods: {
    initLoginTippy(tippy) {
      tippy.popper.id = "loginPopper";
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    enterKeySubmit(event) {
      if (event.keyCode === 13) {
        this.login();
      }
    },
    login() {
      LoginWithUrl(window.loginUrl, {
        username: this.email,
        password: this.password,
        _t: Date.now()
      })
        .then(responseData => {
          if (typeof responseData === "string") {
            this.setLoggedIn(JSON.parse(responseData));
          } else {
            this.setLoggedIn(responseData);
          }
        })
        .catch(error => {
          console.error(error);
          this.loggedIn = false;
          this.openModal();
        });
    },
    logout() {
      logoutWithUrl(window.logoutUrl)
        .then(responseData => {
          if (typeof responseData === "string") {
            this.setLoggedOut(JSON.parse(responseData));
          } else {
          this.setLoggedOut(responseData);
          }
        })
        .catch(error => console.error(error));
    },
    checkLogin(date) {
      let checkLoginUrl = date
        ? window.checkLoginUrl + "?_=" + Date.now()
        : window.checkLoginUrl;
      checkLoginWithUrl(checkLoginUrl)
        .then(responseData => {
          this.isLoggedIn(responseData);
        })
        .catch(error => console.error(error));
    },
    setLoggedIn(data) {
      if (data.status === 1) {
        this.loggedIn = true;
        window.location = this.config.redirectUrl;
      } else {
        this.loggedIn = false;
        this.openModal();
      }
    },
    setLoggedOut(data) {
      if (data.status === 1) {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        this.loggedIn = false;
        window.location = this.config.homepage || "/";
      } else {
        this.loggedIn = true;
      }
    },
    isLoggedIn(data) {
      if (data === true) {
        this.loggedIn = true;
        if (!this.interval) {
          this.interval = setInterval(() => {
            this.checkLogin();
          }, 30000);
        }
      } else {
        if (this.loggedIn) {
          this.logout();
        }
      }
    },
    receiveMessage(event) {
      const shopBaseUrl = new URL(this.config.shopBaseUrl || location.origin);
      if (
        event.origin === shopBaseUrl.origin &&
        event.data === ShopPostMessages.CHECK_LOGIN_STATE
      ) {
        const timeoutForCheckLogin = setTimeout(() => {
          this.checkLogin();
          clearTimeout(timeoutForCheckLogin);
        }, 2000);
      }
    }
  },
  mounted() {
    window.addEventListener("keyup", this.enterKeySubmit);
    window.addEventListener("message", this.receiveMessage, false);
    this.checkLogin(true);
  },
  destroyed() {
    window.removeEventListener("keyup", this.enterKeySubmit);
    window.removeEventListener("message", this.receiveMessage, false);
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
};
</script>

<style module lang="scss">
@import "./ShopLogin.scss";
</style>
